import { Component, OnInit, HostListener } from '@angular/core';
import { ClientesService } from 'src/app/clientes/clientes.service';
import { TablesService } from 'src/app/generico/tables/tables.service';
import { ContratoService } from 'src/app/clientes/crear-contrato/contrato.service';
import { MatDialog } from '@angular/material/dialog';
import { CrearContratoComponent } from 'src/app/clientes/crear-contrato/crear-contrato.component';

@Component({
  selector: 'app-log-contratos',
  templateUrl: './log-contratos.component.html',
  styleUrls: ['./log-contratos.component.scss']
})
export class LogContratosComponent implements OnInit {

  /**datos tabla */
  recurso : string = 'contratos/admincontrato';
  columns : any = ['numero','aplicacion', 'usuarios permitidos', 'tipo contrato', 'fecha inicio', 'fecha fin', 'acciones'];
  params  : any = {};
  nombre_tabla : string = 'contratos_activos';
  target ;
  /** */

  constructor(
    private cli_serv : ClientesService,
    private tb_ser : TablesService,
    private contrato_serv : ContratoService,
    public dialog: MatDialog,
  ) { }

  ngOnInit(): void {
    this.params['ind_activo'] = 0;
    this.params['fk_cliente'] = this.cli_serv.json_cliente.id_cliente;
    this.target = document.querySelector('#btn_log_contrato');
  }

  @HostListener('edit_contrato')
  crearContrato() {

    let json_contrato = this.tb_ser.params_event?.contrato;

    if (json_contrato){
      this.contrato_serv.json_contrato = json_contrato
    }


    const dialogRef = this.dialog.open(CrearContratoComponent, {
      width: '500px',
      height: '500px'
    });

  }

}
